var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.334093 12.9731V11.7752H2.92958L2.6301 11.5356C1.77825 10.8568 1.15932 10.1181 0.773329 9.31944C0.387334 8.52083 0.194336 7.62905 0.194336 6.6441C0.194336 5.23322 0.610279 3.96542 1.44217 2.84071C2.27405 1.716 3.36881 0.940683 4.72645 0.514757V1.7526C3.72819 2.1386 2.92292 2.78082 2.31066 3.67925C1.69839 4.57769 1.39225 5.56597 1.39225 6.6441C1.39225 7.48264 1.54865 8.21137 1.86144 8.83029C2.17423 9.44922 2.59682 9.98495 3.12923 10.4375L3.72819 10.8568V8.38108H4.92611V12.9731H0.334093ZM8.45996 12.6736V11.4158C9.47153 11.0298 10.2768 10.3876 10.8758 9.48915C11.4747 8.59071 11.7742 7.60243 11.7742 6.52431C11.7742 5.88542 11.6178 5.23655 11.305 4.57769C10.9922 3.91884 10.5829 3.33652 10.0771 2.83073L9.49815 2.31163V4.78733H8.30024V0.195312H12.8923V1.39323H10.2768L10.5763 1.67274C11.3749 2.41811 11.9738 3.21672 12.3732 4.06858C12.7725 4.92043 12.9721 5.739 12.9721 6.52431C12.9721 7.93518 12.5595 9.20631 11.7343 10.3377C10.909 11.469 9.8176 12.2477 8.45996 12.6736Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.8c137e50c923e6578986748689a1a9a2.svg";
export { ForwardRef as ReactComponent };